import React, { useEffect, useState } from "react";
import { Paper, Typography, Box, Divider, Chip } from "@mui/material";
import SelectComponent from "../../../ReusableComponents/SelectComponent";
import { changeIssueType } from "../../../apis/BhuMeetTeams/Oparations/requestIssue";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { PDRL_SUCCESS_ENGI_ROUTES } from "../../../routes";
import { allIssueTypes } from "../../../appConstants";
import { squareKilometersToAcres } from "../../../ReusableFunctions/reusableFunctions";
import { max } from "lodash";

const IssueMetaData = ({ issueDetail, restart, request_detail }) => {

  const navigate = useNavigate()
  // Determine chip color based on status
  const getStatusChipColor = (status) => {
    switch (status) {
      case "Open":
        return "success";
      case "Closed":
        return "default";
      default:
        return "default";
    }
  };
  const [refresh, setRefresh] = useState(0);

  const userDetails = useSelector((state) => state.user?.user);

  const [issueType, setIssueType] = useState({ label: issueDetail.type, value: issueDetail.type })
  const [issuePriority, setIssuePriority] = useState({ label: issueDetail.priority, value: issueDetail.priority })

  useEffect(() => {
    console.log(issueType)
  }, [issueType])



  const [priority, setpriority] = useState([{ label: "Low", value: "Low" }, { label: "Medium", value: "Medium" }, { label: "High", value: "High" }
  ])
  useEffect(() => {
    console.log(issueDetail)
    restart(refresh);
  }, [refresh]);

  const updateIssueType = async (currentType, Type) => {
    let role = userDetails.bhumeet_role == 'Admin' ? 'operations' : userDetails.bhumeet_role == 'Telecaller' ? 'telecaller' : 'customerSuccessEngineer'
    if (Type == 'Type') {

      let updateType = await changeIssueType(issueDetail.id, issueDetail.type, currentType, role, "Type")

      setRefresh((prev) => prev + 1);

      issueDetail.type = currentType
    } else {

      let updateType = await changeIssueType(issueDetail.id, issueDetail.priority, currentType, role)

      setRefresh((prev) => prev + 1);

      issueDetail.priority = currentType
    }
  }

  return (
    <>
      <Paper elevation={1} sx={{ p: 2 }}>

        <Typography style={{ fontSize: "1rem", fontWeight: "700" }} variant="span" gutterBottom>
          Issue Details
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {/* Status */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.5,
            }}
          >
            <Typography style={{ fontSize: "1rem", fontWeight: "500" }} variant="body2" color="text.secondary">
              Status
            </Typography>
            <Chip
              label={request_detail.status == 'close' ? 'closed' : 'open' || "NA"}
              color={getStatusChipColor(request_detail.status)}
              size="small"
            />
          </Box>
          <Divider />

          {/* Issue Type */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.5,
            }}
          >
            {/* Left side - Issue Type text */}
            <Typography sx={{ fontSize: "1rem", fontWeight: 500 }} variant="body2" color="text.secondary">Issue Type</Typography>

            {/* Right side - SelectComponent or Text */}
            <Box sx={{ textAlign: (request_detail.status === "close") ? "right" : "left", minWidth: "200px" }}>
              {(request_detail.status === "close") ? (
                <Typography variant="body2" fontWeight="bold">{issueDetail.type || "NA"}</Typography>
              ) : (
                <SelectComponent
                  onChange={(e) => {
                    console.log(e);
                    if (e.value !== issueType.value) {
                      setIssueType(e);
                      updateIssueType(e.value, "Type");
                    }
                  }}
                  name="issue_type"
                  label="Issue Type"
                  list={allIssueTypes}
                  styles={{ width: "200px", height: "10px", fontSize: "13px" }}
                  placeholderText="Select Issue type"
                  isSearchable={true}
                  value={issueType}
                  menuListStyles={{height:"200px"}}
                  containerStyle={{ width: "200px", minHeight: "60px" }}
                />
              )}
            </Box>
          </Box>

          <Divider />

          {/* Priority */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.5,
            }}
          >
            <Typography style={{ fontSize: "1rem", fontWeight: "500" }} variant="body2" color="text.secondary">
              Priority
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {/* {issueDetail.priority || "NA"} */}
              {(request_detail.status == 'close') ? issueDetail.priority || "NA" :
                <SelectComponent
                  onChange={(e) => {
                    console.log(e)
                    if (e.value != issuePriority.value) {
                      setIssuePriority(e)
                      updateIssueType(e.value)
                    }

                  }}
                  name="Priority"
                  label="Priority"
                  list={priority}

                  styles={{ width: "100%", height: "18px", fontSize: "13px" }}
                  // validation={selectFieldValidation}
                  placeholderText="Select Priority"
                  // defaultValue={issueType}
                  value={issuePriority}
                  containerStyle={{ width: "200px", minHeight: "60px" }}
                />
              }

            </Typography>
          </Box>
          <Divider />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.5,
            }}
          >
            <Typography style={{ fontSize: "1rem", fontWeight: "500" }} variant="body2" color="text.secondary">
              Issue Number
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {issueDetail.issue_ticket_id || "NA"}
            </Typography>
          </Box>
          <Divider />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.5,
              cursor: "pointer",
            }}
            onClick={() => {
              console.log(issueDetail)
              navigate(`${PDRL_SUCCESS_ENGI_ROUTES.REQUESTDETAILS}`, {
                state: { request: { type: "Spraying service", id: issueDetail.req_Id, show: true, Data: issueDetail } },
              })
            }}
          >
            <Typography style={{ fontSize: "1rem", fontWeight: "500" }} variant="body2" color="text.secondary">
              Request Number
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {issueDetail.req_number || "NA"}
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Divider/>

      <Paper elevation={1} sx={{ p: 2,marginTop:"5px" }}>

        <Typography style={{ fontSize: "1rem", fontWeight: "700" }} variant="span" gutterBottom>
          Request Details
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {/* Status */}
         

          {/* Issue Type */}
          

          
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.5,
            }}
          >
            <Typography style={{ fontSize: "1rem", fontWeight: "500" }} variant="body2" color="text.secondary">
              Pilot Name
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {`${issueDetail?.pilot_first_name || '-'} ${issueDetail?.pilot_last_name || ''}` || "NA"}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.5,
            }}
          >
            <Typography style={{ fontSize: "1rem", fontWeight: "500" }} variant="body2" color="text.secondary">
              Total Amount
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              ₹{issueDetail.total_amount || "NA"}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.5,
            }}
          >
            <Typography style={{ fontSize: "1rem", fontWeight: "500" }} variant="body2" color="text.secondary">
            Request Status
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {issueDetail.request_status || "NA"}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.5,
            }}
          >
            <Typography style={{ fontSize: "1rem", fontWeight: "500" }} variant="body2" color="text.secondary">
              {issueDetail.price_by == 'tank' ? 'Requested No of Tank' : 'Requested Area'}
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {!isNaN(issueDetail.requested_area) ? issueDetail.price_by == 'tank' ? issueDetail.requested_area : Number(squareKilometersToAcres(issueDetail.requested_area)).toFixed(2) + ' Acre' : "0"}
            </Typography>
          </Box>
            {request_detail.status == 'Paid' && 
            <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.5,
            }}
          >
            <Typography style={{ fontSize: "1rem", fontWeight: "500" }} variant="body2" color="text.secondary">
              Completed Area
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {issueDetail.service_completed_area ? Number(squareKilometersToAcres(issueDetail.service_completed_area)).toFixed(4) : "0"}
            </Typography>
          </Box>  
            }
          

          
          
          
        </Box>
      </Paper>

    </>

  );
};

export default IssueMetaData;
